module.exports = __webpack_public_path__ + "static/img/1.10b3682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-contrastistas-proveedores/1.png
// module id = M2mP
// module chunks = 0